const WhyChooseUsSection = () => {

    return (
        <section className="w-full bg-[#E6F3CD] py-[40px]">
            <div className="w-full flex flex-col items-center">
                <div className="xs:w-full w-[90%] sm:w-[70%] lg:w-full h-[180px] sm:h-[150px] flex items-center justify-center">
                    <h1 className="font-bold font-playfair xs:text-[30px] text-[50px] md:text-[65px] text-[#41220E]">Why Choose Us</h1>
                </div>
                <div className="w-[80%] xl:w-[70%] flex flex-col items-center my-10">
                    <div className="w-full flex flex-col justify-center items-center md:flex-row md:justify-between space-y-16 md:space-y-0 py-5">
                        <div className="relative w-[260px] md:w-[200px] lg:w-[260px] h-[380px] mx-auto group">
                            <div className={`w-full h-[300px] bg-catering-artisanal-quality bg-center bg-cover rounded-xl transition-transform duration-500 ease-in-out`}
                            ></div>
                            <div className={`flex items-center h-[80px] pl-2 transition-transform duration-500 ease-in-out`}>
                                <p className="text-[18px] sm:text-[20px] font-semibold text-[#41220E] font-montserrat">Artisanal Quality</p>
                            </div>
                        </div>
                        <div className="relative w-[260px] md:w-[200px] lg:w-[260px] h-[380px] mx-auto group">
                            <div className={`w-full h-[300px] bg-catering-customisation bg-center bg-cover rounded-xl transition-transform duration-500 ease-in-out`}
                            ></div>
                            <div className={`flex items-center h-[80px] pl-2 transition-transform duration-500 ease-in-out`}>
                                <p className="text-[18px] sm:text-[20px] font-semibold text-[#41220E] font-montserrat">Customization</p>
                            </div>
                        </div>
                        <div className="relative w-[260px] md:w-[200px] lg:w-[260px] h-[380px] mx-auto group">
                            <div className={`w-full h-[300px] bg-catering-freshness bg-center bg-cover rounded-xl transition-transform duration-500 ease-in-out`}
                            ></div>
                            <div className={`flex items-center h-[80px] pl-2 transition-transform duration-500 ease-in-out`}>
                                <p className="text-[18px] sm:text-[20px] font-semibold text-[#41220E] font-montserrat">Freshness</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default WhyChooseUsSection
